export default __webpack_public_path__ + "static/media/banner-sobre-nos-desktop.976eda46.png";